import { Autocomplete, TextField, Checkbox } from "@mui/material";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
// import { useState } from "react";

interface SingleTextAcProps {
  header: string;
  data: any[];
  filters: Record<string, any>;
  setFilters: (filters: Record<string, any>) => void;
  customFieldName?: string;
}

const SingleTexOldtAc: React.FC<SingleTextAcProps> = ({
  header,
  data,
  filters,
  setFilters,
  customFieldName,
}) => {
  const value = filters[header]?.keywords || [];

  return (
    <Autocomplete
      multiple
      limitTags={2}
      disableCloseOnSelect
      value={value}
      options={data.filter(Boolean)} // Remove null/undefined values
      getOptionLabel={(option) => option?.toString() || ''}
      isOptionEqualToValue={(option, value) => option === value}
      onChange={(_, newValue) => {
        setFilters({
          ...filters,
          [header]: {
            comparator: "equals",
            keywords: newValue,
          },
        });
      }}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={customFieldName || header}
          size="small"
          InputProps={{
            ...params.InputProps,
            sx: { minHeight: 40 }
          }}
        />
      )}
      sx={{
        minWidth: 200,
        '& .MuiAutocomplete-tag': {
          maxWidth: '80%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }
      }}
    />
  );
};

export default SingleTexOldtAc;
